// @flow
// $FlowFixMe<
import React, { useMemo, useState, useEffect } from "react";
import { get } from "lodash";
import type { RaceCardBettingInterest } from "@tvg/types/Race";
import { getRunner } from "@tvg/utils/getRaceAtiveRunner";
import { formatOdds } from "../../_organism/HorseSwitcher";
import {
  RunnerOddsContainer,
  OddsContainer,
  MorningOdds,
  CommentsContainer,
  Comment,
  SilkContainer,
  Silk,
  Odd,
  RunnerOddsWrapper
} from "./styled-components";
import Icon from "../../_static/Icons";
import { caretUp, caretDown } from "../../_static/Icons/icons";
import buildColor from "../../_static/ColorPalette";

type Props = {
  activeRunnerBI: RaceCardBettingInterest,
  activeRunner: string,
  noRunnerCommentMessage: string,
  isSilkShown: boolean
};

const HorseOddsPP = (props: Props) => {
  const [hasSilkError, setSilkError] = useState(false);

  const { activeRunnerBI, activeRunner, noRunnerCommentMessage, isSilkShown } =
    props;

  const runner = useMemo(
    () => getRunner(activeRunnerBI, activeRunner),
    [activeRunnerBI, activeRunner]
  );
  const silkUrlSvg = get(runner, "timeform.silkUrlSvg");

  useEffect(() => {
    setSilkError(false);
  }, [silkUrlSvg]);

  return useMemo(
    () =>
      runner ? (
        <RunnerOddsWrapper>
          <RunnerOddsContainer>
            <OddsContainer>
              <MorningOdds>
                ML {formatOdds(activeRunnerBI.morningLineOdds)}
              </MorningOdds>
              {activeRunnerBI.recentOdds &&
                activeRunnerBI.recentOdds
                  .map((odd, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <Odd key={`odd-${index}`}>
                      {odd.trending !== null &&
                        index !==
                          get(activeRunnerBI, "recentOdds.length") - 1 && (
                          <Icon
                            icon={!odd.trending ? caretUp : caretDown}
                            size={15}
                            color={
                              !odd.trending
                                ? buildColor("green", "500")
                                : buildColor("red", "500")
                            }
                          />
                        )}
                      {odd.odd}
                    </Odd>
                  ))
                  .reverse()}
            </OddsContainer>
            <CommentsContainer>
              <Comment>
                {get(
                  runner,
                  "timeform.analystsComments",
                  noRunnerCommentMessage
                ) || noRunnerCommentMessage}
              </Comment>
            </CommentsContainer>
          </RunnerOddsContainer>
          {isSilkShown && !!silkUrlSvg && !hasSilkError && (
            <SilkContainer>
              <Silk src={silkUrlSvg} onError={() => setSilkError(true)} />
            </SilkContainer>
          )}
        </RunnerOddsWrapper>
      ) : null,
    [
      runner,
      isSilkShown,
      activeRunner,
      JSON.stringify(activeRunnerBI),
      hasSilkError
    ]
  );
};

HorseOddsPP.defaultProps = {
  activeRunner: "",
  noRunnerCommentMessage: "",
  isSilkShown: true
};

export default HorseOddsPP;
